import React from 'react';
import { motion } from 'framer-motion';

const SmartClassBanner = () => {
  return (
    <div className="w-full bg-[#020617] py-14 relative overflow-hidden border-y border-white/5 font-sans">
      
      {/* --- BACKGROUND CINEMATIC LIGHTING --- */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-red-600/5 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[500px] h-[500px] bg-blue-600/10 rounded-full blur-[120px]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          
          {/* --- LEFT: TECH STATUS --- */}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
            <div className="flex items-center gap-3 mb-3">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
              </span>
              <span className="text-[10px] text-white/40 font-black uppercase tracking-[0.4em]">Core Technology Partner</span>
            </div>
            <h3 className="text-3xl md:text-4xl font-black text-white tracking-tighter leading-none">
              Powered by <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-500 uppercase">Smart Class™</span>
            </h3>
            <p className="text-indigo-200/20 text-[10px] font-bold mt-3 uppercase tracking-[0.5em]">Next-Gen Learning Ecosystem</p>
          </div>

          {/* --- MIDDLE: FLARE IT BRANDING --- */}
          <div className="flex flex-col items-center group cursor-default">
            <div className="text-[9px] text-white/30 font-black uppercase tracking-[0.5em] mb-4">Crafted with precision by</div>
            <div className="relative">
              <h2 className="text-5xl md:text-6xl font-black text-white tracking-tighter leading-none">
                FLARE <span className="text-red-600">IT</span><span className="text-blue-500">.COM</span>
              </h2>
              {/* Modern animated bar decoration */}
              <div className="mt-4 flex justify-center gap-1">
                <div className="h-1 w-8 bg-red-600 rounded-full group-hover:w-16 transition-all duration-500"></div>
                <div className="h-1 w-2 bg-blue-500 rounded-full group-hover:scale-150 transition-all duration-500"></div>
              </div>
            </div>
          </div>

          {/* --- RIGHT: CONTACT ACTION --- */}
          <div className="flex flex-col items-center lg:items-end">
            <a 
              href="tel:+94761007063" 
              className="group relative px-10 py-5 bg-white/[0.02] border border-white/10 rounded-[2rem] overflow-hidden transition-all duration-500 hover:border-red-600/30 hover:bg-white/[0.05] shadow-2xl"
            >
              <div className="relative z-10 flex flex-col items-center lg:items-end">
                <span className="text-[10px] text-red-500 font-black uppercase tracking-widest mb-1 group-hover:tracking-[0.2em] transition-all">Support Hotline</span>
                <span className="text-2xl md:text-3xl font-black text-white tracking-tighter group-hover:text-red-600 transition-colors">
                   076 100 7063
                </span>
              </div>
              
              {/* Subtle background glow on hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-red-600/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
            </a>
          </div>

        </div>

        {/* --- BOTTOM: ARCHITECTURE | DESIGN | INNOVATION --- */}
        <div className="mt-16 flex flex-col items-center justify-center space-y-4 select-none pointer-events-none">
          <div className="flex items-center gap-4 md:gap-8 opacity-20">
            {/* Left Decorative Line */}
            <div className="h-[1px] w-12 md:w-24 bg-gradient-to-r from-transparent to-white"></div>
            
            {/* Keywords with Professional Spacing */}
            <div className="flex gap-4 md:gap-6 text-[9px] md:text-[11px] font-bold text-white uppercase tracking-[0.3em]">
              <span>Architecture</span>
              <span className="text-red-600 opacity-50">•</span>
              <span>Design</span>
              <span className="text-blue-500 opacity-50">•</span>
              <span>Innovation</span>
            </div>
            
            {/* Right Decorative Line */}
            <div className="h-[1px] w-12 md:w-24 bg-gradient-to-l from-transparent to-white"></div>
          </div>

          {/* Subtle System Tag */}
          <p className="text-[8px] font-medium text-white/10 uppercase tracking-[0.2em]">
            Standard Version 4.0 // Build 2026.04
          </p>
        </div>
      </div>

    </div>
  );
};

export default SmartClassBanner;